import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form__error-message" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_PasswordInput = _resolveComponent("PasswordInput")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_FormSubmitButton = _resolveComponent("FormSubmitButton")!
  const _component_FormGroup = _resolveComponent("FormGroup")!

  return (_openBlock(), _createBlock(_component_FormGroup, {
    name: "login",
    class: "login-form",
    layout: "vertical",
    "wrapper-col": { span: 24 },
    model: _ctx.loginForm,
    onFinish: _ctx.submitForm,
    loading: _ctx.loading
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, { class: "ant-row ant-row-center login-form__email-row" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "username",
                rules: [
            _ctx.makeRequiredRule(_ctx.t('Please enter Email')),
            !_ctx.overrideEmailValidation &&
              _ctx.makeEmailRule(_ctx.t('Please enter a valid Email')),
            _ctx.makeLatinCharRule(),
          ],
                validateFirst: true,
                validateStatus: !!_ctx.tokenAuthParsedError && 'error'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TextInput, {
                    value: _ctx.loginForm.username,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.username) = $event)),
                    label: _ctx.t('Email'),
                    onChange: _ctx.resetErrorMessage,
                    type: "email"
                  }, null, 8, ["value", "label", "onChange"])
                ]),
                _: 1
              }, 8, ["rules", "validateStatus"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, { class: "ant-row ant-row-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                class: _normalizeClass([
            'login-form__password',
            !!_ctx.tokenAuthParsedError && 'form__api-error',
          ]),
                name: "password",
                rules: [
            _ctx.makeRequiredRule(_ctx.t('Please enter Password')),
            _ctx.makeLatinCharRule(),
          ],
                validateStatus: !!_ctx.tokenAuthParsedError && 'error'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PasswordInput, _mergeProps({
                    label: _ctx.t('Password')
                  }, _ctx.$attrs, {
                    value: _ctx.loginForm.password,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                    disableWhileLoading: _ctx.loading,
                    onChange: _ctx.resetErrorMessage
                  }), null, 16, ["label", "value", "disableWhileLoading", "onChange"])
                ]),
                _: 1
              }, 8, ["class", "rules", "validateStatus"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_typography_text, { type: "danger" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.tokenAuthParsedError), 1)
          ]),
          _: 1
        })
      ]),
      (_ctx.captcha.isCaptchaEnabled)
        ? (_openBlock(), _createBlock(_component_vue_recaptcha, {
            key: 0,
            class: "login-form__captcha",
            ref: "vueRecaptcha",
            siteKey: _ctx.captcha.recaptchaSiteKey,
            size: "invisible",
            theme: "dark",
            tabindex: 0,
            "loading-timeout": _ctx.config.loadingTimeoutInMs,
            onVerify: _ctx.captcha.recaptchaVerified,
            onExpire: _ctx.captcha.recaptchaError,
            onFail: _ctx.captcha.recaptchaError
          }, null, 8, ["siteKey", "loading-timeout", "onVerify", "onExpire", "onFail"]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_row, { class: "ant-row ant-row-center login-form__button" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { xs: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_BasicButton, {
                disabled: _ctx.loading,
                onClick: _ctx.forgotPassword
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Forgot password?")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            class: "mb-8",
            xs: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FormSubmitButton, { loading: _ctx.loading }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Log in")), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            class: "mb-8",
            xs: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BasicButton, {
                id: "login-form__registration",
                disabled: _ctx.loading,
                onClick: _ctx.createNewAccount
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Create new account")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { xs: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_BasicButton, {
                disabled: _ctx.loading,
                onClick: _ctx.onFooterBtnClick
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.AccountLinkIcon,
                    class: "px-10 pb-3"
                  }, null, 8, _hoisted_2)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.loginBtnText), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "onFinish", "loading"]))
}